import { FC } from 'react';
import SpriteIcon from '../shared/sprite-icon';
import { useTranslation } from '../../hooks/use-translation';
import { kImageFolderUrl } from '../../services/constants';
import { useClassName } from '../../hooks/use-class-name';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

// -----------------------------------------------------------------------------
export const DeleteAReviewModal: FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
}): JSX.Element => {
  const { t } = useTranslation();

  const className = useClassName(
    {
      'modal-is-open': isOpen,
    },
    'delete-review-modal',
  );

  return (
    <div className="delete-review-modal-container">
      <div className={className}>
        <div className="modal-main">
          <button className="clean-icon-btn close-modal" onClick={onClose}>
            <SpriteIcon icon="closeSmall" />
          </button>

          <img
            src={`${kImageFolderUrl}/reviews/skull.svg`}
            alt="Delete Icon"
            className="skull-icon"
          />

          <h2>{t('deleteReviewTitle')}</h2>
          <p>
            {t('deleteReviewDescription')}
          </p>

          {isDeleting ? (
            <div className="modal-actions-loading">
              <div className="rotating-loader modal-loader">
                <SpriteIcon icon="loader" />
              </div>
            </div>
          ) : (
            <div className="modal-actions">
              <button className="btn-secondary cancel-btn" onClick={onClose}>
                {t('cancel')}
              </button>
              <button className="btn-primary delete-btn" onClick={onConfirm}>
                {t('deleteBtn')}
              </button>
            </div>
          )}
        </div>
        <div className="bg" onClick={!isDeleting ? onClose : undefined} />
      </div>
    </div>
  );
};
